import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs/Rx';

import { TestTakerActions, AppUiActions } from '../../../../../../store/actions';
import * as fromRoot from '../../../../../../store/reducers';
import { HtmlService } from './../../../../../../services/html.service';
import { TestNavigationService } from '../../../../../../services/test-navigation.service';
import { TestTakerService } from '../../../../../../services/test-taker.service';
import { TestContentService } from '../../../../../../services/test-content.service';
import { ResponseService } from '../../../../../../services/response.service';
import { MyModal } from './../../../../../common/my-modal/my-modal.component';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Component({
    selector: 'ipp-end-of-test',
    template: require('./ipp-end-of-test.component.html')
})

export class IppEndOfTestComponent {
    @Input() htmlResourceId: number;
    private testName: string;
    private endOfTestDescription: string
    private htmlContentReady: boolean = false;

    assessmentTest$: Observable<PgRendererDto.AssessmentTest>;
    private assessmentTestSubscription: Subscription;
    assessmentTest: PgRendererDto.AssessmentTest;

    associatedAssessmentTests$: Observable<number[]>;
    private associatedAssessmentTestsSubscription: Subscription;
    associatedAssessmentTests: number[];

    constructor(
        private store: Store<fromRoot.State>,
        private htmlService: HtmlService,
        private testNavigationService: TestNavigationService,
        private testTakerService: TestTakerService,
        private testContentService: TestContentService,
        private responseService: ResponseService,
        private myModal: MyModal,
        private sanitizer: DomSanitizer
    ) {
        this.assessmentTest$ = store.select(fromRoot.getAssessmentTest);
        this.assessmentTestSubscription = this.assessmentTest$.subscribe(assessmentTest => {
            this.assessmentTest = assessmentTest;
        });

        this.associatedAssessmentTests$ = store.select(fromRoot.getAssociatedAssessmentTests);
        this.associatedAssessmentTestsSubscription = this.associatedAssessmentTests$.subscribe(associatedAssessmentTests => {
            this.associatedAssessmentTests = associatedAssessmentTests;
        });

        this.testNavigationService.setCanGoNext(false);
    }

    ngOnInit() {
        this.testName = this.assessmentTest.Title;
        this.getPostTestDescription();
        this.htmlContentReady = false;
    }

    resetTest() {
        var landingPageTestlet = this.testNavigationService.getTestlets(this.assessmentTest)[0];
        var landingPageNavigation = landingPageTestlet.testNavigation;
        this.store.dispatch(new TestTakerActions.SetTestNavigation(landingPageNavigation));
        this.resetInteractions();
    }

    resetInteractions() {
        var testletIds = [];
        var interactions = [];
        var testletDefs = [];

        this.testNavigationService.getTestlets(this.assessmentTest).forEach(t => {
            testletIds.push(t.testletId)
        });

        this.testContentService.getTestlets(testletIds, this.assessmentTest.Identifier).subscribe(
            testletDefs => {
                testletDefs.forEach(t => {
                    var testletInteractions = this.testContentService.getReferencedInteractionsByTestlet(t);
                    testletInteractions.forEach(i => {
                        this.responseService.clearInteractionResponses(i.InteractionId);
                    });
                });
        });
    }

    getPostTestDescription() {
        this.htmlService.getHtmlResource(this.htmlResourceId).subscribe(html => {
            this.endOfTestDescription = this.sanitizer.bypassSecurityTrustHtml(html) as string;
            this.htmlContentReady = true;
        });
    }
}


// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-end-of-test/ipp-end-of-test.component.ts